import type { InviteUser } from '@fourthwall/services/dist/ShopUsersApiClient'
import { ShopUsersApiClient } from '@fourthwall/services/dist/ShopUsersApiClient'
import { useMutation } from '@tanstack/react-query'

export const useUserInviteMutation = () => {
  const userInviteMutation = useMutation({
    mutationFn: async (variables: InviteUser['Payload']) => {
      const { data } = await ShopUsersApiClient.inviteUser(variables)

      return data
    },
  })

  return { userInviteMutation }
}
